import React from 'react';
import { SxStyle } from '../../types';
import { useLocation, Link } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

const styles: SxStyle = {
  selectedMenuItem: {
    backgroundColor: 'rgba(13, 49, 104, 1)',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: 'rgba(13, 49, 104, 0.9)',
    },
  },
  NotSelectedMenuItem: {
    backgroundColor: 'rgba(7, 34, 72, 0.6)',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: 'rgba(13, 49, 104, 1)',
    },
  },
  selectedMenuItem2: {
    backgroundColor: 'rgba(144, 202, 249, 0.16)',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: 'rgba(144, 202, 249, 0.16)',
    },
  },
  NotSelectedMenuItem2: (theme) => ({
    backgroundColor: theme.palette.menu.main,
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: 'rgba(144, 202, 249, 0.16)',
    },
  }),
  iconColorNotSelected: {
    color: 'rgba(255, 255, 255, 0.5)',
    minWidth: 'auto',
    mr: 2,
  },
  iconColorSelected: {
    color: 'rgba(255, 255, 255, 1)',
    minWidth: 'auto',
    mr: 2,
  },
  textEllipse: {
    '& .MuiListItemText-primary': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: '14px',
      lineHeight: '16px',
    },
  },
};

interface Props {
  id: string;
  to: string;
  text: string;
  classSelect: string;
  icon?: JSX.Element;
  isSubItem?: boolean;
  isTeam?: boolean;
  isLink?: boolean;
}

const MenuListItem = ({ id, to, text, classSelect, icon, isSubItem, isTeam, isLink }: Props) => {
  const location = useLocation();
  const currentRoute = location.pathname.split('/')[1];
  const sx = (() => {
    const isSelected = currentRoute === classSelect;
    if (isTeam && isSelected) {
      return styles.selectedMenuItem2;
    }
    if (isTeam && !isSelected) {
      return styles.NotSelectedMenuItem2;
    }

    if (isSelected) {
      return styles.selectedMenuItem;
    }

    return styles.NotSelectedMenuItem;
  })();

  const buttonProps = isLink
    ? {
        href: to,
        target: '_blank',
      }
    : {
        component: Link,
        to,
      };

  return (
    <ListItemButton
      key={id}
      sx={sx}
      style={isSubItem ? { paddingLeft: '32px', flexGrow: 0 } : { flexGrow: 0 }}
      {...buttonProps}
    >
      <ListItemIcon
        sx={currentRoute === classSelect ? styles.iconColorSelected : styles.iconColorNotSelected}
      >
        {icon}
      </ListItemIcon>
      <ListItemText sx={styles.textEllipse} primary={text} />
    </ListItemButton>
  );
};

export default MenuListItem;
